import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

import {LEVEL_COLORS} from './consts';
import type {MatrixHeatmapCell, MatrixHeatmapRowData} from './types';

import styles from './matrix-heatmap.module.css';

interface Props {
    row: MatrixHeatmapRowData;
    hasMetric: boolean;
}

export function MatrixHeatmapRow(props: Props) {
    const {row, hasMetric} = props;

    return (
        <Stack spacing={8} isHorizontal={true} alignItems='center'>
            <div
                className={styles['matrix-heatmap-row-label']}
                data-tip={
                    row.secondaryText ? `${row.primaryText}, ${row.secondaryText}` : row.primaryText
                }
                data-place='top'
                data-effect='solid'
            >
                <Body size='normal' color='dark' isBold={true} truncate={{type: 'inline'}}>
                    {row.primaryText}
                </Body>
                {row.secondaryText && (
                    <Body size='small' color='medium' truncate={{type: 'inline'}}>
                        {row.secondaryText}
                    </Body>
                )}
            </div>
            {hasMetric && (
                <div
                    className={styles['matrix-heatmap-metric']}
                    data-tip={row.metricDataTip ?? row.metricText}
                    data-place='top'
                    data-effect='solid'
                >
                    {row.metricText && (
                        <Body size='small' color='medium' isBold={true} truncate={{type: 'inline'}}>
                            {row.metricText}
                        </Body>
                    )}
                </div>
            )}
            <Stack spacing={4} isHorizontal={true}>
                {row.cells.map((cell: MatrixHeatmapCell, i: number) => (
                    <div
                        key={i}
                        className={styles['matrix-heatmap-cell']}
                        style={{backgroundColor: LEVEL_COLORS[cell.level]}}
                        data-tip={cell.dataTip}
                        data-place='top'
                        data-effect='solid'
                    />
                ))}
            </Stack>
        </Stack>
    );
}
